import { observer } from "mobx-react-lite";
import { Navigate, Outlet } from "react-router-dom";
import { usePageContext } from "../context/PageContext";

const PublicLayout = observer(() => {
  const { pageStore } = usePageContext();

  if (pageStore.isAuth) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
});

export default PublicLayout;
